// These constants are injected via webpack environment variables.
// You can add more variables in webpack.common.js or in profile specific webpack.<dev|prod>.js files.
// If you change the values in the webpack config files, you need to re run webpack to update the application

import { Authority } from '@/shared/security/authority';

export const VERSION = process.env.VERSION;
// export const DEBUG_INFO_ENABLED: boolean = !!process.env.DEBUG_INFO_ENABLED;
export const SERVER_API_URL = process.env.SERVER_API_URL;
export const BUILD_TIMESTAMP = process.env.BUILD_TIMESTAMP;

// Errors
export const PROBLEM_BASE_URL = 'https://www.jhipster.tech/problem';
export const EMAIL_ALREADY_USED_TYPE = PROBLEM_BASE_URL + '/email-already-used';
export const LOGIN_ALREADY_USED_TYPE = PROBLEM_BASE_URL + '/login-already-used';
export const PHONE_ALREADY_USED_TYPE = PROBLEM_BASE_URL + '/phone-number-already-used';
export const URL_S3_POLARIS = '/polaris/polaris.weboffice.js';

// Image Uri Thumbnail Url
export const IMAGE_THUMBNAIL_URL = 'https://dzh91b51qfr7r.cloudfront.net/company/thumbnail/';

export const THEMES = [
  { value: 'system', text: 'myPage.setting.themeTab.optionText.sync' },
  { value: 'light', text: 'myPage.setting.themeTab.optionText.light' },
  { value: 'dark', text: 'myPage.setting.themeTab.optionText.dark' },
];

export const USER_LANGUAGES = [
  { value: 'ko', text: 'myPage.setting.languageTab.majorLanguage.optionText.korean' },
  { value: 'en', text: 'myPage.setting.languageTab.majorLanguage.optionText.english' },
];

export const CONTENT_LANGUAGES = [
  { value: 'en', label: 'English' },
  { value: 'ko', label: '한국어' },
];

export const PATTERN = {
  PHONE: /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/,
  REPLACE_PHONE_REGEX: /[\s()-]/g,
};

export const USER_STATE_PAYMENT = {
  NEW_FREE_USER: 'NEW_FREE_USER',
  EXIST_USER: 'EXIST_USER',
  NEW_USER: 'NEW_USER',
  PRO_END: 'PRO_END',
  INVITE_SUCCESS: 'INVITE_SUCCESS',
};

export const DUE_DATE_MAKE_A_THON = '2025/09/25';

export const WIDGET_STATUS = {
  NODATA: 'NO_DATA',
  ERROR: 'ERROR',
  LOADING: 'LOADING',
};

export const STATE_USER_TRIAL = {
  NON_EXIST: 'NON_EXIST',
  TRIALING: 'TRIALING',
  EXPIRED: 'EXPIRED',
};

export const MY_CREATE_TYPES = {
  ASK_GOOVER: 'Ask Goover',
  REPORT: 'Report',
  JOURNALIST_NOTE: 'Journalist Note',
  SOCIAL_MEDIA: 'Social Media Posting',
};

export enum COMPANY_WIDGET_TYPE {
  ReportInsight = 'ReportInsight',
  Discovery = 'Discovery',
  BriefingNow = 'BriefingNow',
  People = 'People',
  Company = 'Company',
  PeopleQuote = 'PeopleQuote',
  SNSData = 'SNSData',
  BuzzSummary = 'BuzzSummary',
  CompanyWiki = 'CompanyWiki',
  NtfSummary = 'NtfSummary',
  ExpertReport = 'ExpertReport',
  CompanyRelationCompany = 'CompanyRelationCompany',
  InvestInformation = 'InvestInformation',
  FinanceSummary = 'FinanceSummary',
  StockTrendsSummary = 'StockTrendsSummary',
  StockMarketConditionSummary = 'StockMarketConditionSummary',
}

export const MAX_TIME_OUT_SECONDS = 35000;

export const REPORT_NO_BRIEFING_TEXT_ID = 'reportNoBriefing';

export enum REPORT_TOAST_STATUS {
  LOADING = 'loading',
  SUCCESS = 'success',
  FAILED = 'failed',
}

export enum REPORT_TOAST_STATUS_CODE {
  SUCCESS = '200',
  NOT_ENOUGH_REFERENCES = '422',
  OVER_REFERENCES = '413',
  SYSTEM_ERROR = '500',
}

export enum PAID_FEATURE_IDX {
  ASK_GOOVER = 1,
  IN_DEPT_REPORT = 2,
  ACTIVE_SCRAP_AGENT = 3,
  SCRAP_AGENT_SPEED = 4,
  SCRAP_AGENT_STORAGE = 5,
  MY_AGENT_QUANTITY = 6,
}

export const MAX_TIME_OUT_FOR_LOADING_REPORT = 1200000;

export const TIME_CHECK_LOADING_REPORT = 60000;

export enum REFERENCE_TAB_SELECT {
  FILES = 'FILES',
  SEARCH = 'SEARCH',
  URL = 'URL',
  NOTE = 'NOTE',
  MY_SCRAP = 'MY_SCRAP',
}

export enum PAYMENT_PRICE {
  PRO1 = 20,
  PRO2 = 100,
  PRO3 = 180,
  ULTRA1 = 50,
  ULTRA2 = 250,
  ULTRA3 = 450,
}

export const PAYMENT_MNT = [
  { productId: 0, price: PAYMENT_PRICE.PRO1, period: 30, productName: 'trial', productType: 100, view: 'Pro' },
  { productId: 1, price: PAYMENT_PRICE.PRO1, period: 1, productName: 'pro1', productType: 100, view: 'Pro' },
  { productId: 5, price: PAYMENT_PRICE.PRO1, period: 30, productName: 'pro1', productType: 100, view: 'Pro' },
  { productId: 6, price: PAYMENT_PRICE.PRO2, period: 180, productName: 'pro6', productType: 100, view: 'Pro' },
  { productId: 7, price: PAYMENT_PRICE.PRO3, period: 365, productName: 'pro12', productType: 100, view: 'Pro' },
  { productId: 8, price: PAYMENT_PRICE.ULTRA1, period: 30, productName: 'ultra1', productType: 200, view: 'Ultra' },
  { productId: 9, price: PAYMENT_PRICE.ULTRA2, period: 180, productName: 'ultra6', productType: 200, view: 'Ultra' },
  { productId: 10, price: PAYMENT_PRICE.ULTRA3, period: 365, productName: 'ultra12', productType: 200, view: 'Ultra' },
];

export const TIME_OUT_ADD_LOADING_REPORT = 1;

export enum ROLE {
  ROLE_USER = Authority.USER,
  ROLE_GUEST = Authority.GUEST,
  ROLE_PAID_PRO = Authority.PRO_USER,
  ROLE_PAID_ULTRA = Authority.ULTRA_USER,
}

export const ROUTE_NAME_NOT_CREATE_GUEST = [
  'Login',
  'Register',
  'ReportDetail',
  'TopicDetail',
  'TopicDetail',
  'PrivacyPolicy',
  'PrivacyPolicy',
];

export const ROUTE_NAME_REQUIRED_ACCOUNT = [
  'MyBriefing',
  'MyBriefing-All',
  'MyBriefing-Detail',
  'SocialBriefing-All',
  'SocialBriefing-Detail',
  'UserMyPageComponent',
  'MyCreateAsk',
];

export const MY_CREATE_ROUTE_NAME_ACTIVE = [
  'UserMyCreate',
  'MyCreateAsk',
  'MyCreateReport',
  'MyCreateJournalist',
  'MyCreateSocial',
  'MyCreatePodcast',
];

export const SCRAP_AGENT_ROUTE_NAME_ACTIVE = ['ScrapAgent', 'ScrapAgent-All', 'ScrapAgent-Detail'];

export const MY_BRIEFING_ROUTE_NAME_ACTIVE = [
  'MyBriefing',
  'MyBriefing-All',
  'MyBriefing-Detail',
  'SocialBriefing-All',
  'SocialBriefing-Detail',
  'CompanyBriefing-All',
  'CompanyBriefing-Detail',
  'SocialUser',
  'MyRecap',
];

export const COUNTRIES = [
  { label: '대한민국 +82', value: 'KR' },
  { label: 'United States +1', value: 'US' },
  { label: 'Vietnam +84', value: 'VN' },
  { label: 'Afghanistan +93', value: 'AF' },
  { label: 'Albania +355', value: 'AL' },
  { label: 'Algeria +213', value: 'DZ' },
  { label: 'American Samoa +1', value: 'AS' },
  { label: 'Andorra +376', value: 'AD' },
  { label: 'Angola +244', value: 'AO' },
  { label: 'Anguilla +1', value: 'AI' },
  { label: 'Antarctica +672', value: 'AQ' },
  { label: 'Antigua and Barbuda +1', value: 'AG' },
  { label: 'Argentina +54', value: 'AR' },
  { label: 'Armenia +374', value: 'AM' },
  { label: 'Aruba +297', value: 'AW' },
  { label: 'Australia +61', value: 'AU' },
  { label: 'Austria +43', value: 'AT' },
  { label: 'Azerbaijan +994', value: 'AZ' },
  { label: 'Bahamas +1', value: 'BS' },
  { label: 'Bahrain +973', value: 'BH' },
  { label: 'Bangladesh +880', value: 'BD' },
  { label: 'Barbados +1', value: 'BB' },
  { label: 'Belarus +375', value: 'BY' },
  { label: 'Belgium +32', value: 'BE' },
  { label: 'Belize +501', value: 'BZ' },
  { label: 'Benin +229', value: 'BJ' },
  { label: 'Bermuda +1', value: 'BM' },
  { label: 'Bhutan +975', value: 'BT' },
  { label: 'Bolivia +591', value: 'BO' },
  { label: 'Bosnia and Herzegovina +387', value: 'BA' },
  { label: 'Botswana +267', value: 'BW' },
  { label: 'Brazil +55', value: 'BR' },
  { label: 'British Indian Ocean Territory +246', value: 'IO' },
  { label: 'British Virgin Islands +1', value: 'VG' },
  { label: 'Brunei +673', value: 'BN' },
  { label: 'Bulgaria +359', value: 'BG' },
  { label: 'Burkina Faso +226', value: 'BF' },
  { label: 'Myanmar +95', value: 'MM' },
  { label: 'Burundi +257', value: 'BI' },
  { label: 'Cambodia +855', value: 'KH' },
  { label: 'Cameroon +237', value: 'CM' },
  { label: 'Canada +1', value: 'CA' },
  { label: 'Cape Verde +238', value: 'CV' },
  { label: 'Cayman Islands +1', value: 'KY' },
  { label: 'Central African Republic +236', value: 'CF' },
  { label: 'Chad +235', value: 'TD' },
  { label: 'Chile +56', value: 'CL' },
  { label: 'China +86', value: 'CN' },
  { label: 'Christmas Island +61', value: 'CX' },
  { label: 'Cocos Islands +61', value: 'CC' },
  { label: 'Colombia +57', value: 'CO' },
  { label: 'Comoros +269', value: 'KM' },
  { label: 'Republic of the Congo +242', value: 'CG' },
  { label: 'Democratic Republic of the Congo +243', value: 'CD' },
  { label: 'Cook Islands +682', value: 'CK' },
  { label: 'Costa Rica +506', value: 'CR' },
  { label: 'Croatia +385', value: 'HR' },
  { label: 'Cuba +53', value: 'CU' },
  { label: 'Curacao +599', value: 'CW' },
  { label: 'Cyprus +357', value: 'CY' },
  { label: 'Czech Republic +420', value: 'CZ' },
  { label: 'Denmark +45', value: 'DK' },
  { label: 'Djibouti +253', value: 'DJ' },
  { label: 'Dominica +1', value: 'DM' },
  { label: 'Dominican Republic +1', value: 'DO' },
  { label: 'East Timor +670', value: 'TL' },
  { label: 'Ecuador +593', value: 'EC' },
  { label: 'Egypt +20', value: 'EG' },
  { label: 'El Salvador +503', value: 'SV' },
  { label: 'Equatorial Guinea +240', value: 'GQ' },
  { label: 'Eritrea +291', value: 'ER' },
  { label: 'Estonia +372', value: 'EE' },
  { label: 'Ethiopia +251', value: 'ET' },
  { label: 'Falkland Islands +500', value: 'FK' },
  { label: 'Faroe Islands +298', value: 'FO' },
  { label: 'Fiji +679', value: 'FJ' },
  { label: 'Finland +358', value: 'FI' },
  { label: 'France +33', value: 'FR' },
  { label: 'French Polynesia +689', value: 'PF' },
  { label: 'Gabon +241', value: 'GA' },
  { label: 'Gambia +220', value: 'GM' },
  { label: 'Georgia +995', value: 'GE' },
  { label: 'Germany +49', value: 'DE' },
  { label: 'Ghana +233', value: 'GH' },
  { label: 'Gibraltar +350', value: 'GI' },
  { label: 'Greece +30', value: 'GR' },
  { label: 'Greenland +299', value: 'GL' },
  { label: 'Grenada +1', value: 'GD' },
  { label: 'Guam +1', value: 'GU' },
  { label: 'Guatemala +502', value: 'GT' },
  { label: 'Guernsey +44', value: 'GG' },
  { label: 'Guinea +224', value: 'GN' },
  { label: 'Guinea-Bissau +245', value: 'GW' },
  { label: 'Guyana +592', value: 'GY' },
  { label: 'Haiti +509', value: 'HT' },
  { label: 'Honduras +504', value: 'HN' },
  { label: 'Hong Kong +852', value: 'HK' },
  { label: 'Hungary +36', value: 'HU' },
  { label: 'Iceland +354', value: 'IS' },
  { label: 'India +91', value: 'IN' },
  { label: 'Indonesia +62', value: 'ID' },
  { label: 'Iran +98', value: 'IR' },
  { label: 'Iraq +964', value: 'IQ' },
  { label: 'Ireland +353', value: 'IE' },
  { label: 'Isle of Man +44', value: 'IM' },
  { label: 'Israel +972', value: 'IL' },
  { label: 'Italy +39', value: 'IT' },
  { label: 'Ivory Coast +225', value: 'CI' },
  { label: 'Jamaica +1', value: 'JM' },
  { label: 'Japan +81', value: 'JP' },
  { label: 'Jersey +44', value: 'JE' },
  { label: 'Jordan +962', value: 'JO' },
  { label: 'Kazakhstan +7', value: 'KZ' },
  { label: 'Kenya +254', value: 'KE' },
  { label: 'Kiribati +686', value: 'KI' },
  { label: 'Kosovo +383', value: 'XK' },
  { label: 'Kuwait +965', value: 'KW' },
  { label: 'Kyrgyzstan +996', value: 'KG' },
  { label: 'Laos +856', value: 'LA' },
  { label: 'Latvia +371', value: 'LV' },
  { label: 'Lebanon +961', value: 'LB' },
  { label: 'Lesotho +266', value: 'LS' },
  { label: 'Liberia +231', value: 'LR' },
  { label: 'Libya +218', value: 'LY' },
  { label: 'Liechtenstein +423', value: 'LI' },
  { label: 'Lithuania +370', value: 'LT' },
  { label: 'Luxembourg +352', value: 'LU' },
  { label: 'Macau +853', value: 'MO' },
  { label: 'Macedonia +389', value: 'MK' },
  { label: 'Madagascar +261', value: 'MG' },
  { label: 'Malawi +265', value: 'MW' },
  { label: 'Malaysia +60', value: 'MY' },
  { label: 'Maldives +960', value: 'MV' },
  { label: 'Mali +223', value: 'ML' },
  { label: 'Malta +356', value: 'MT' },
  { label: 'Marshall Islands +692', value: 'MH' },
  { label: 'Mauritania +222', value: 'MR' },
  { label: 'Mauritius +230', value: 'MU' },
  { label: 'Mayotte +262', value: 'YT' },
  { label: 'Mexico +52', value: 'MX' },
  { label: 'Micronesia +691', value: 'FM' },
  { label: 'Moldova +373', value: 'MD' },
  { label: 'Monaco +377', value: 'MC' },
  { label: 'Mongolia +976', value: 'MN' },
  { label: 'Montenegro +382', value: 'ME' },
  { label: 'Montserrat +1', value: 'MS' },
  { label: 'Morocco +212', value: 'MA' },
  { label: 'Mozambique +258', value: 'MZ' },
  { label: 'Namibia +264', value: 'NA' },
  { label: 'Nauru +674', value: 'NR' },
  { label: 'Nepal +977', value: 'NP' },
  { label: 'Netherlands +31', value: 'NL' },
  { label: 'Netherlands Antilles +599', value: 'AN' },
  { label: 'New Caledonia +687', value: 'NC' },
  { label: 'New Zealand +64', value: 'NZ' },
  { label: 'Nicaragua +505', value: 'NI' },
  { label: 'Niger +227', value: 'NE' },
  { label: 'Nigeria +234', value: 'NG' },
  { label: 'Niue +683', value: 'NU' },
  { label: 'Northern Mariana Islands +1', value: 'MP' },
  { label: 'North Korea +850', value: 'KP' },
  { label: 'Norway +47', value: 'NO' },
  { label: 'Oman +968', value: 'OM' },
  { label: 'Pakistan +92', value: 'PK' },
  { label: 'Palau +680', value: 'PW' },
  { label: 'Palestine +970', value: 'PS' },
  { label: 'Panama +507', value: 'PA' },
  { label: 'Papua New Guinea +675', value: 'PG' },
  { label: 'Paraguay +595', value: 'PY' },
  { label: 'Peru +51', value: 'PE' },
  { label: 'Philippines +63', value: 'PH' },
  { label: 'Pitcairn +64', value: 'PN' },
  { label: 'Poland +48', value: 'PL' },
  { label: 'Portugal +351', value: 'PT' },
  { label: 'Puerto Rico +1', value: 'PR' },
  { label: 'Qatar +974', value: 'QA' },
  { label: 'Reunion +262', value: 'RE' },
  { label: 'Romania +40', value: 'RO' },
  { label: 'Russia +7', value: 'RU' },
  { label: 'Rwanda +250', value: 'RW' },
  { label: 'Saint Barthelemy +590', value: 'BL' },
  { label: 'Samoa +685', value: 'WS' },
  { label: 'San Marino +378', value: 'SM' },
  { label: 'Sao Tome and Principe +239', value: 'ST' },
  { label: 'Saudi Arabia +966', value: 'SA' },
  { label: 'Senegal +221', value: 'SN' },
  { label: 'Serbia +381', value: 'RS' },
  { label: 'Seychelles +248', value: 'SC' },
  { label: 'Sierra Leone +232', value: 'SL' },
  { label: 'Singapore +65', value: 'SG' },
  { label: 'Sint Maarten +1', value: 'SX' },
  { label: 'Slovakia +421', value: 'SK' },
  { label: 'Slovenia +386', value: 'SI' },
  { label: 'Solomon Islands +677', value: 'SB' },
  { label: 'Somalia +252', value: 'SO' },
  { label: 'South Africa +27', value: 'ZA' },
  { label: 'South Sudan +211', value: 'SS' },
  { label: 'Spain +34', value: 'ES' },
  { label: 'Sri Lanka +94', value: 'LK' },
  { label: 'Saint Helena +290', value: 'SH' },
  { label: 'Saint Kitts and Nevis +1', value: 'KN' },
  { label: 'Saint Lucia +1', value: 'LC' },
  { label: 'Saint Martin +590', value: 'MF' },
  { label: 'Saint Pierre and Miquelon +508', value: 'PM' },
  { label: 'Saint Vincent and the Grenadines +1', value: 'VC' },
  { label: 'Sudan +249', value: 'SD' },
  { label: 'Suriname +597', value: 'SR' },
  { label: 'Svalbard and Jan Mayen +47', value: 'SJ' },
  { label: 'Swaziland +268', value: 'SZ' },
  { label: 'Sweden +46', value: 'SE' },
  { label: 'Switzerland +41', value: 'CH' },
  { label: 'Syria +963', value: 'SY' },
  { label: 'Taiwan +886', value: 'TW' },
  { label: 'Tajikistan +992', value: 'TJ' },
  { label: 'Tanzania +255', value: 'TZ' },
  { label: 'Thailand +66', value: 'TH' },
  { label: 'Togo +228', value: 'TG' },
  { label: 'Tokelau +690', value: 'TK' },
  { label: 'Tonga +676', value: 'TO' },
  { label: 'Trinidad and Tobago +1', value: 'TT' },
  { label: 'Tunisia +216', value: 'TN' },
  { label: 'Turkey +90', value: 'TR' },
  { label: 'Turkmenistan +993', value: 'TM' },
  { label: 'Turks and Caicos Islands +1', value: 'TC' },
  { label: 'Tuvalu +688', value: 'TV' },
  { label: 'United Arab Emirates +971', value: 'AE' },
  { label: 'Uganda +256', value: 'UG' },
  { label: 'United Kingdom +44', value: 'GB' },
  { label: 'Ukraine +380', value: 'UA' },
  { label: 'Uruguay +598', value: 'UY' },
  { label: 'Uzbekistan +998', value: 'UZ' },
  { label: 'Vanuatu +678', value: 'VU' },
  { label: 'Vatican +379', value: 'VA' },
  { label: 'Venezuela +58', value: 'VE' },
  { label: 'U.S. Virgin Islands +1', value: 'VI' },
  { label: 'Wallis and Futuna +681', value: 'WF' },
  { label: 'Western Sahara +212', value: 'EH' },
  { label: 'Yemen +967', value: 'YE' },
  { label: 'Zambia +260', value: 'ZM' },
  { label: 'Zimbabwe +263', value: 'ZW' },
];

export enum REFERENCE_TYPE {
  FILE = 'FILE',
  NOTE = 'NOTE',
}

export enum REFERENCE_FILE_TYPE {
  PDF = 'PDF',
  DOC = 'DOC',
  PPT = 'PPT',
}

export enum REFERENCE_STYLE_FOR {
  BRIEFING_REFERENCE = 'BRIEFING_REFERENCE',
  EDIT_REFERENCE = 'EDIT_REFERENCE',
  REPORT_REFERENCE = 'REPORT_REFERENCE',
}

export const FILE_TYPES = ['.doc', '.docx', '.ppt', '.pptx', '.pdf'];

export enum FILE_TYPES_ENUM {
  PDF = 'pdf',
  DOT_PDF = '.pdf',
  DOC = 'doc',
  DOT_DOC = '.doc',
  DOCX = 'docx',
  DOT_DOCX = '.docx',
  PPT = 'ppt',
  DOT_PPT = '.ppt',
  PPTX = 'pptx',
  DOT_PPTX = '.pptx',
}

export enum SVG_FILE {
  PDF = '/content/images/images_v3/common/go-icon-document/file-pdf-fill.svg',
  DOC = '/content/images/images_v3/common/go-icon-document/file-word-fill.svg',
  PPT = '/content/images/images_v3/common/go-icon-document/file-ppt-fill.svg',
}

export enum ASK_GOOVER_EVENT_TYPE {
  ANSWER_STREAM = 'answer_stream',
  ANSWER_STREAM_START = 'answer_stream_start',
  ACTIVITY_CONTENT = 'activity_content',
  ACTIVITY_STREAM = 'activity_stream',
  ANSWER_STREAM_END = 'answer_stream_end',
  REFERENCE_DOCUMENT = 'reference_document',
  SUGGEST = 'suggest',
}

export type TAB_CHANNEL = 'ALL' | 'CLOUD' | 'SOCIAL' | 'BLOG' | 'RSS' | 'EMAIL' | 'URL' | 'META_SEARCH';

export const DISCOVERY_DISPLAY_TYPE = {
  GRID: 0,
  LIST: 1,
} as const;

export const DISCOVERY_CONTENT_TYPE = {
  ALL: null,
  MY: ['MYCONTENT'],
  SOCIAL: ['SOCIALCONTENT'],
  COMPANY: ['COMPANY'],
  PEOPLE: ['PEOPLE'],
} as const;

export const DISCOVERY_BLOG_TYPE = {
  ALL: ['NAVER_BLOG', 'BRUNCH', 'WORDPRESS', 'MEDIUM'],
  NAVER_BLOG: ['NAVER_BLOG'],
  BRUNCH: ['BRUNCH'],
  WORDPRESS: ['WORDPRESS'],
  MEDIUM: ['MEDIUM'],
} as const;

export const DISCOVERY_CLOUD_TYPE = {
  ALL: ['GOOGLE_DRIVE', 'ONE_DRIVE', 'DROP_BOX'],
  GOOGLE_DRIVE: ['GOOGLE_DRIVE'],
  ONE_DRIVE: ['ONE_DRIVE'],
  DROP_BOX: ['DROP_BOX'],
} as const;

export const DISCOVERY_EMAIL_TYPE = {
  ALL: ['GMAIL', 'NAVER', 'DAUM', 'OUTLOOK', 'YAHOO'],
  GMAIL: ['GMAIL'],
  NAVER_MAIL: ['NAVER'],
  DAUM_MAIL: ['DAUM'],
  OUTLOOK: ['OUTLOOK'],
  YAHOO_MAIL: ['YAHOO'],
} as const;

export const DISCOVERY_SOCIAL_TYPE = {
  ALL: ['X_TWITTER', 'REDDIT', 'YOUTUBE'],
  FACEBOOK: ['FACEBOOK'],
  TWITTER: ['X_TWITTER'],
  REDDIT: ['REDDIT'],
  YOUTUBE: ['YOUTUBE'],
} as const;

export const DISCOVERY_SCRAP_TYPE = {
  ALL: null,
  CLOUD: DISCOVERY_CLOUD_TYPE.ALL,
  BLOG: DISCOVERY_BLOG_TYPE.ALL,
  SOCIAL: DISCOVERY_SOCIAL_TYPE.ALL,
  EMAIL: DISCOVERY_EMAIL_TYPE.ALL,
  URL: ['REALTIME_CRAWLER', 'WEB_CRAWLER', 'URL'],
  RSS: ['RSS'],
  META_SEARCH: ['MS_TOPIC'],
} as const;

export const DISCOVERY_BRIEFING_TYPE = {
  ALL: ['REPORT', 'TOPIC_SUMMARY', 'DISCOVERY_SCRAPE', 'DISCOVERY', 'DOCUMENT', 'VIDEO', 'SOCIAL', 'COMPANY'],
  REPORT: ['REPORT'],
  TOPIC: ['TOPIC_SUMMARY'],
  DISCOVERY_SCRAPE: ['DISCOVERY_SCRAPE'],
  WEB: ['DISCOVERY', 'DOCUMENT'],
  AGENT: ['AGENT'],
  COMPANY: ['COMPANY'],
  PEOPLE: ['PEOPLE'],
  IMAGE: ['IMAGE'],
  VIDEO: ['VIDEO'],
  SOCIAL: ['SOCIAL'],
} as const;

export const DISCOVERY_TAB_TYPE = {
  ALL: ['REPORT', 'TOPIC_SUMMARY', 'DISCOVERY_SCRAPE', 'SCRAPE', 'DISCOVERY', 'DOCUMENT', 'VIDEO', 'SOCIAL', 'COMPANY'],
  REPORT: ['REPORT'],
  TOPIC: ['TOPIC_SUMMARY'],
  SCRAPE: ['DISCOVERY_SCRAPE', 'SCRAPE'],
  WEB: ['DISCOVERY', 'DOCUMENT'],
  AGENT: ['AGENT'],
  COMPANY: ['COMPANY'],
  PEOPLE: ['PEOPLE'],
  IMAGE: ['IMAGE'],
  VIDEO: ['VIDEO'],
  SOCIAL: ['SOCIAL'],
} as const;

export enum GOOVER_WIDZAD {
  CREATE_REPORT = 'CREATE_REPORT',
  JOURNALIST_NOTE = 'JOURNALIST_NOTE',
  SOCIAL_MEDIA_POSTING = 'SOCIAL_MEDIA_POSTING',
  PODCAST = 'PODCAST',
  CREATE_BRIEFING_AGENT = 'CREATE_BRIEFING_AGENT',
  CREATE_CONNECT_AGENT = 'CREATE_CONNECT_AGENT',
}

export const COMPANY_USER_KEY = 'UID_04e7c4ad-4835-413f-ad23-2a619ed28fbb';

export enum TYPE_CHANGE_PLAN {
  UPGRADE = 'UPGRADE',
  DOWNGRADE = 'DOWNGRADE',
  CANCEL = 'CANCEL',
  USE_SAME = 'USE_SAME',
  CHANGE_ALREADY_SCHEDULE = 'CHANGE_ALREADY_SCHEDULE',
}

export type DATASOURCE_TYPE =
  | 'EVERY_THING'
  | 'DATA_TYPE'
  | 'URL'
  | 'KEYWORD'
  | 'PROFILE'
  | 'TOPIC'
  | 'NEW_FEED'
  | 'MY_CHANNEL'
  | 'MY_SUBSCRIPTION'
  | 'TRENDING'
  | 'MY_PROFILE'
  | 'INBOX';

export const DATA_FILE_TYPE = [
  { value: 'DOCUMENT', label: 'Document (doc, docx, odt…)' },
  { value: 'EXCEL', label: 'Excel (xls, xlsx, csv…)' },
  { value: 'PPT', label: 'Presentations (ppt, pptx…)' },
  { value: 'PDF', label: 'PDF file' },
  // { value: 'SPECIFIC_FILE', label: 'Specific file' },
  { value: 'TEXT', label: 'TXT' },
  { value: 'HTML', label: 'HTML' },
  // { value: 'IMAGE', label: 'Image' },
  // { value: 'SPECIFIC_FOLDER', label: 'Specific folder' },
  { value: 'HWP', label: 'HWP' },
];

export const CHANNEL_DATASOURCE_TYPE = {
  GOOGLE_DRIVE: [
    {
      type: 'EVERY_THING',
      multiple: false,
    },
    {
      type: 'DATA_TYPE',
      multiple: false,
    },
  ],
  DROP_BOX: [
    {
      type: 'EVERY_THING',
      multiple: false,
    },
    {
      type: 'DATA_TYPE',
      multiple: false,
    },
  ],
  ONE_DRIVE: [
    {
      type: 'EVERY_THING',
      multiple: false,
    },
    {
      type: 'DATA_TYPE',
      multiple: false,
    },
  ],
  FACEBOOK: [
    {
      type: 'NEW_FEED',
      multiple: false,
    },
    {
      type: 'PROFILE',
      multiple: false,
    },
  ],
  YOUTUBE: [
    {
      type: 'TRENDING',
      multiple: false,
    },
    {
      type: 'MY_SUBSCRIPTION',
      multiple: false,
    },
    {
      type: 'MY_CHANNEL',
      multiple: false,
    },
    {
      type: 'URL',
      multiple: false,
    },
    {
      type: 'KEYWORD',
      multiple: false,
    },
  ],
  X_TWITTER: [
    {
      type: 'MY_PROFILE',
      multiple: false,
    },
    {
      type: 'PROFILE',
      multiple: false,
    },
    {
      type: 'KEYWORD',
      multiple: false,
    },
  ],
  GMAIL: [
    {
      type: 'INBOX',
      multiple: false,
    },
  ],
  DAUM: [
    {
      type: 'INBOX',
      multiple: false,
    },
  ],
  NAVER: [
    {
      type: 'INBOX',
      multiple: false,
    },
  ],
  OUTLOOK: [
    {
      type: 'INBOX',
      multiple: false,
    },
  ],
  WORDPRESS: [
    {
      type: 'MY_PROFILE',
      multiple: false,
    },
    {
      type: 'URL',
      multiple: false,
    },
  ],
  BRUNCH: [
    {
      type: 'PROFILE',
      multiple: false,
    },
    {
      type: 'KEYWORD',
      multiple: false,
    },
  ],
  MEDIUM: [
    {
      type: 'URL',
      multiple: false,
    },
  ],
  MS_TOPIC: [
    {
      type: 'KEYWORD',
      multiple: true,
    },
  ],
  REALTIME_CRAWLER: [
    {
      type: 'URL',
      multiple: false,
    },
  ],
  WEB_CRAWLER: [
    {
      type: 'URL',
      multiple: false,
    },
  ],
  URL: [
    {
      type: 'URL',
      multiple: false,
    },
  ],
  RSS: [
    {
      type: 'URL',
      multiple: false,
    },
  ],
  NAVER_BLOG: [
    {
      type: 'PROFILE',
      multiple: false,
    },
    {
      type: 'TOPIC',
      multiple: false,
    },
    {
      type: 'KEYWORD',
      multiple: false,
    },
  ],
} as { [key: string]: { type: DATASOURCE_TYPE; multiple: boolean }[] };

export type OATH2_PROVIDER = 'GOOGLE' | 'MICROSOFT' | 'DROP_BOX' | 'FACEBOOK' | 'X_TWITTER' | 'WORDPRESS';

export enum LOADING_DATA_TYPE {
  REPORT = 'REPORT',
  REPORT_BRIEFING = 'REPORT_BRIEFING',
  JOURNALIST_NOTE = 'JOURNALIST_NOTE',
  SOCIAL_MEDIA_POSTING = 'SOCIAL_MEDIA_POSTING',
  PODCAST = 'PODCAST',
  BRIEFING_AGENT = 'BRIEFING_AGENT',
  CONNECT_AGENT = 'CONNECT_AGENT',
}

export enum MEDIA_LOADING_DATA_TYPE {
  REPORT = 'REPORT',
  JOURNAL_NOTE = 'JOURNAL_NOTE',
  SOCIAL_MEDIA = 'SOCIAL_MEDIA',
  PODCAST = 'PODCAST',
}

export enum IMAGES {
  USER_DEFAULT = 'https://static.vecteezy.com/system/resources/thumbnails/009/292/244/small/default-avatar-icon-of-social-media-user-vector.jpg',
}

export const TIME_DISPLAY_SUCCESS_TOAST_REPORT = 30000;

export const TIME_OUT_ALL_LOADING_CREATE = 1200000;

export const CREATE_PODCAST = 'CREATE_PODCAST';

export const SAVE_TYPE_REPORT = 'REPORT';

export const DOCUMENT_TYPE_REPORT = 'REPORT';

export const CONTENT_TYPE_MY_CONTENT = 'MYCONTENT';

export enum DATA_SOURCE_CHAT {
  BASIC = 'BASIC',
  FINANCE = 'FINANCE',
  RND = 'RND',
  PATENT = 'PATENT',
  LAW = 'LAW',
}

export enum ROLE_CHAT {
  USER = 'user',
  ASSISTANT = 'assistant',
}

export enum REPORT_TYPES {
  DAILY = 'DAILY',
  PRODUCT_REVIEW = 'PRODUCT_REVIEW',
  INVESTMENT = 'INVESTMENT',
  JOURNAL_NOTE = 'JOURNAL_NOTE',
  DAILY_BLOG = 'DAILY_BLOG',
  PRODUCT_REVIEW_BLOG = 'PRODUCT_REVIEW_BLOG',
  INVESTMENT_BLOG = 'INVESTMENT_BLOG',
  JOURNAL_NOTE_BLOG = 'JOURNAL_NOTE_BLOG',
  DEFAULT = 'DEFAULT',
  INDEPTH_DAILY = 'INDEPTH_DAILY',
  SOCIAL_MEDIA = 'SOCIAL_MEDIA',
  SOCIAL_MEDIA_BLOG = 'SOCIAL_MEDIA_BLOG',
  SOCIAL_MEDIA_FACEBOOK = 'SOCIAL_MEDIA_FACEBOOK',
  SOCIAL_MEDIA_X = 'SOCIAL_MEDIA_X',
  SOCIAL_MEDIA_YOUTUBE = 'SOCIAL_MEDIA_YOUTUBE',
}

export enum REPORT_STYLES {
  DEFAULT = 'DEFAULT',
  BUSINESS = 'BUSINESS',
  BLOG = 'BLOG',
  FACEBOOK = 'FACEBOOK',
  X = 'X',
  YOUTUBE = 'YOUTUBE',
}

export enum PRIVACY_TYPES {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
}

export enum MEDIA_TYPES {
  JOURNAL_NOTE = 'JOURNAL_NOTE',
  JOURNAL_NOTE_BLOG = 'JOURNAL_NOTE_BLOG',
  SOCIAL_MEDIA = 'SOCIAL_MEDIA',
  SOCIAL_MEDIA_BLOG = 'SOCIAL_MEDIA_BLOG',
}
